module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "auto",
      "width": "auto"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade2"
    }
  }, [(_vm.showModal('addCatagory')) ? _c('add-catagory') : _vm._e(), _vm._v(" "), (_vm.showModal('addJewelry')) ? _c('add-jewelry') : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3625b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 220
// module chunks = 1